import { createReducer, on } from '@ngrx/store';
import { HelocState } from '../../models/heloc.model';
import * as HelocActions from './heloc.actions';

export const initialHelocState: HelocState = {
  applications: [],
  currentApplication: null,
  loading: false,
  submitting: false,
  error: null,
  success: false,
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0
};

export const helocReducer = createReducer(
  initialHelocState,
  on(HelocActions.submitHelocApplication, state => ({
    ...state,
    submitting: true,
    error: null,
    success: false
  })),
  on(HelocActions.submitHelocApplicationSuccess, (state, { application }) => ({
    ...state,
    submitting: false,
    currentApplication: application,
    success: true,
    error: null
  })),
  on(HelocActions.submitHelocApplicationFailure, (state, { error }) => ({
    ...state,
    submitting: false,
    success: false,
    error
  })),
  on(HelocActions.getHelocApplications, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(HelocActions.getHelocApplicationsSuccess, (state, { page }) => ({
    ...state,
    loading: false,
    applications: page.result,
    pageNumber: page.pageNumber,
    pageSize: page.pageSize,
    totalRecords: page.totalRecords,
    error: null
  })),
  on(HelocActions.getHelocApplicationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(HelocActions.getHelocApplicationById, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(HelocActions.getHelocApplicationByIdSuccess, (state, { application }) => ({
    ...state,
    loading: false,
    currentApplication: application,
    error: null
  })),
  on(HelocActions.getHelocApplicationByIdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(HelocActions.resetHelocState, () => initialHelocState)
);
